import React, { createContext, useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { isBrowser, isMobile } from 'react-device-detect';
import './appLayout.scss';
export function getLayoutSize() {
  if (window.innerWidth < 500) {
    return 'XS';
  } else if (window.innerWidth < 900) {
    return 'S';
  } else if (window.innerWidth < 1300) {
    return 'M';
  } else if (window.innerWidth < 1600) {
    return 'L';
  } else {
    return 'XL';
  }
}
;
var initialLayoutSize = getLayoutSize();
var initialAppLayout = {
  colorMode: 'lightMode',
  layoutSize: initialLayoutSize,
  isBrowser,
  isMobile,
  menuOverlay: isMobile || ['XS', 'S'].includes(initialLayoutSize)
};
export var AppLayoutContext = /*#__PURE__*/createContext(initialAppLayout);

function AppLayout(props) {
  var {
    className
  } = props;
  var [colorMode] = useState(props.colorMode || initialAppLayout.colorMode);
  var [layoutSize, setLayoutSize] = useState(initialAppLayout.layoutSize);
  var [menuOverlay] = useState(initialAppLayout.menuOverlay);
  useEffect(() => {
    var handleWindowResize = () => {
      var newLayoutSize = getLayoutSize();

      if (newLayoutSize !== layoutSize) {
        setLayoutSize(newLayoutSize);
      }
    };

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, [layoutSize]);
  return /*#__PURE__*/React.createElement(AppLayoutContext.Provider, {
    value: {
      colorMode,
      layoutSize,
      isBrowser,
      isMobile,
      menuOverlay
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: `appLayout ${colorMode} layout${layoutSize} ${className ?? ''}`
  }, /*#__PURE__*/React.createElement(Outlet, null)));
}

export default AppLayout;